import { Box, Typography } from "@mui/material";
import accessdeniedlogo from "../../images/access_denied_logo.png";

const AcccessDenied = () => {
  return (
    <Box
      sx={{
        p: 4,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        gap: "20px",
      }}
    >
      <img
        src={accessdeniedlogo}
        alt="Page Access Denied"
        style={{ width: 400, marginBottom: "10px" }}
      />
      <Typography variant="h5">
        You do not have permission to view this page.
      </Typography>
      <Typography variant="body1">
        Please raise a request to the concerned team for access.
      </Typography>
    </Box>
  );
};

export default AcccessDenied;
